import React from 'react';
import { DataPackageV2Component } from '@vivli/shared/features/data-package/components';
import { useActiveUserContext, useDataRequestsApiContext } from '@vivli/core/infrastructure/context';

import { first } from 'rxjs/operators';
import { IDataRequest } from '@vivli/features/data-requests/infrastructure/interface';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

interface SignedDocumentsDataPackageFeatureProps {
    dataPackageId: string;
    dataRequest: IDataRequest;
}

export const SignedDocumentsDataPackageFeature = ({ dataPackageId, dataRequest }: SignedDocumentsDataPackageFeatureProps) => {
    const { user, hasPermission } = useActiveUserContext();
    const dataRequestsService = useDataRequestsApiContext();
    const isVivliAdmin = hasPermission(PermissionsEnum.DrActAdv); // TODO PERMFE - replace with permissions+

    const handleOnFileAdded = () => {
        dataRequestsService.notifyOfDuaUpload(dataRequest.id).pipe(first()).subscribe();
    };

    const isResearchTeamMember = dataRequest.researchTeam?.researchTeamDetails?.some((a) => a.email === user.email);

    return (
        <DataPackageV2Component
            dataPackageId={dataPackageId}
            readOnly={!isVivliAdmin && !isResearchTeamMember}
            allowDownload={true}
            allowUpload={isVivliAdmin || isResearchTeamMember}
            allowSubmit={false}
            hideFileType={true}
            showUploadDate={true}
            onFileAdded={handleOnFileAdded}
        />
    );
};
